import { render, staticRenderFns } from "./SectionItemCategory.vue?vue&type=template&id=365ee7d3&scoped=true&lang=pug&"
import script from "./SectionItemCategory.vue?vue&type=script&lang=js&"
export * from "./SectionItemCategory.vue?vue&type=script&lang=js&"
import style0 from "./SectionItemCategory.vue?vue&type=style&index=0&id=365ee7d3&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "365ee7d3",
  null
  
)

export default component.exports